import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiExternalLink } = FiIcons;

const Portfolio = () => {
  const items = [
    { title: 'WatchSafe', desc: 'Parental screen-time and YouTube filtering.', url: 'https://watchsafe.app', status: 'Live', icon: 'https://i.imgur.com/Nl4cAr5.png' },
    { title: 'KeepsakeVault', desc: 'Memory and keepsake storage.', url: 'https://keepsakevault.app', status: 'Live', icon: 'https://i.imgur.com/T0V4TJZ.png' },
    { title: 'RouteCaster', desc: 'Advanced route planning and navigation.', url: 'https://routecaster.app', status: 'In Testing', icon: 'https://i.imgur.com/Lc6WQQS.png' },
    { title: 'OrganizeMe', desc: 'AI-powered email and task triage.', url: 'https://organizeMe.click', status: 'In Testing', icon: 'https://i.imgur.com/r8MzVf3.png' },
    { title: 'HomeschoolSD.org', desc: 'A homeschool community site for South Dakota families.', url: 'https://homeschoolsd.org', status: 'Active Client Project', icon: 'https://i.imgur.com/5NyAhOy.png' },
    { title: 'ChildThrive.org', desc: "Preserves foster children's history.", url: 'https://childthrive.org', status: 'In Testing', icon: 'https://i.imgur.com/ywsgdFy.png' },
    { title: 'SoulChronicle', desc: 'A guided writing tool for autobiography or testimony.', url: 'https://soulchronicle.app', status: 'Live', icon: 'https://i.imgur.com/zniVEB5.png' },
    { title: 'WordCascade', desc: 'A fast, touch-optimized word puzzle game for mobile.', url: 'https://wordcascade.app', status: 'Live', icon: 'https://i.imgur.com/BUZrkgV.png' },
    { title: 'LogiColor', desc: 'A modern, cross-platform take on the classic color-logic puzzle game.', url: 'https://logicolor.app', status: 'Live', icon: 'https://i.imgur.com/ghbz2u7.png' },
    { title: 'Quantum Gambit', desc: 'A blind-move strategy game.', url: 'https://quantumgambit.app', status: 'Live', icon: 'https://i.imgur.com/gEseoss.png' },
    { title: 'ScriptLoop', desc: 'Record your voice, drop in text, app creates voices or songs to sing along with.', url: 'https://scriptloop.app', status: 'In Testing', icon: 'https://i.imgur.com/zniVEB5.png' },
    { title: 'Palette Genius', desc: 'Paint-by-numbers with real brush strokes.', url: 'https://palettegenius.app', status: 'Live', icon: 'https://i.imgur.com/3cYkm2l.png' },
    { title: 'CraftSuite', desc: 'All-in-one business management for makers.', url: 'https://craftsuite.app', status: 'Live', icon: 'https://i.imgur.com/77v76Et.png' },
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'Live': return 'bg-[#3b82f6]/20 text-[#3b82f6] border-[#3b82f6]/30';
      case 'In Testing': return 'bg-[#07113a] text-[#94a3b8] border-[#344271]';
      case 'Active Client Project': return 'bg-[#3b82f6]/40 text-white border-[#3b82f6]/50';
      default: return 'bg-[#2a3658] text-[#e2e8f0] border-[#344271]';
    }
  };

  return (
    <section className="pt-40 pb-24 bg-[#07113a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-20">
          <span className="text-[#3b82f6] font-bold tracking-[0.2em] uppercase text-xs mb-4 block">Product Studio</span>
          <h1 className="text-5xl md:text-7xl font-black text-white mb-6 tracking-tight uppercase font-montserrat">Product Portfolio</h1>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item, index) => (
            <motion.a
              key={index}
              href={item.url !== '#' ? item.url : undefined}
              target="_blank"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05 }}
              viewport={{ once: true }}
              className="group bg-[#2a3658] border border-[#344271] p-8 rounded-[32px] transition-all duration-300 flex flex-col backdrop-blur-sm shadow-xl hover:bg-[#344271] hover:border-[#3b82f6]/40 relative overflow-hidden"
            >
              <div className="absolute top-6 right-6 z-10">
                <SafeIcon icon={FiExternalLink} className="text-white/30 group-hover:text-[#3b82f6] transition-colors w-5 h-5" />
              </div>

              <div className="flex flex-col h-full">
                <div className="flex items-center justify-between mb-8 pr-10">
                  <div className="w-24 h-24 bg-white rounded-2xl flex items-center justify-center p-3 border border-[#344271] group-hover:border-[#3b82f6]/30 overflow-hidden transition-all shadow-inner">
                    {item.icon ? (
                      <img 
                        src={item.icon} 
                        alt={item.title} 
                        className="w-full h-full object-contain transition-transform group-hover:scale-110" 
                        referrerPolicy="no-referrer" 
                      />
                    ) : (
                      <span className="font-black text-2xl text-[#3b82f6]">{item.title[0]}</span>
                    )}
                  </div>
                </div>

                <div className="mb-4">
                  <span className={`inline-block text-[10px] font-black uppercase tracking-[0.2em] px-3 py-1.5 rounded-full border mb-4 ${getStatusColor(item.status)}`}>
                    {item.status}
                  </span>
                  <h3 className="text-2xl font-black text-white mb-3 tracking-tight uppercase font-montserrat">{item.title}</h3>
                  <p className="text-[#e2e8f0] leading-relaxed text-base font-medium opacity-90">{item.desc}</p>
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;